import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7af5f539"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-stretch h-[3.25rem]" }
const _hoisted_2 = {
  key: 0,
  class: "left-column font-light flex flex-row items-stretch content-center space-x-5 relative top-[0.5px] text-base"
}
const _hoisted_3 = { class: "flex flex-row items-stretch" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold font-md" }, "Ulixee", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Home", -1))
const _hoisted_6 = { class: "flex flex-row items-stretch" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Docs", -1))
const _hoisted_8 = { class: "flex-1 flex flex-row justify-end" }
const _hoisted_9 = {
  key: 0,
  class: "w-full"
}
const _hoisted_10 = {
  key: 1,
  class: "px-[2px] border-l border-gray-300"
}
const _hoisted_11 = { class: "flex flex-row items-center" }
const _hoisted_12 = { class: "px-[2px] border-l border-gray-300" }
const _hoisted_13 = {
  "aria-label": "Discord",
  href: "//discord.gg/tMAycnemHU",
  class: "block h-[34px] w-[34px] pt-[5px] text-center rounded hover:bg-ulixee-verylight",
  target: "_blank",
  title: "Join our discord"
}
const _hoisted_14 = { class: "flex flex-row items-center" }
const _hoisted_15 = { class: "px-[2px] border-l border-gray-300" }
const _hoisted_16 = {
  "aria-label": "Discord",
  href: "https://github.com/ulixee",
  class: "block h-[34px] w-[34px] pt-[5px] text-center rounded hover:bg-ulixee-verylight",
  target: "_blank",
  title: "Open Ulixee's Github"
}
const _hoisted_17 = { class: "flex flex-row items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_DocumentationMenu = _resolveComponent("DocumentationMenu")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_SearchForm = _resolveComponent("SearchForm")!
  const _component_MenuVersion = _resolveComponent("MenuVersion")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.isFixed ? 'pt-[3.25rem]' : '', _ctx.isDark ? 'isDark' : ''])
  }, [
    _createElementVNode("nav", {
      class: _normalizeClass([[_ctx.isFixed ? 'fixed' : '', _ctx.isDark ? 'border-black' : 'border-gray-300'], "w-full top-0 border-b px-5 text-sm z-50"]),
      style: _normalizeStyle({ backgroundColor: _ctx.backgroundColor })
    }, [
      (_ctx.searchIsActive)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args))),
            class: "absolute top-0 left-0 h-full z-40 inset-0 bg-black bg-opacity-30",
            style: {"height":"calc(100% + 1px)"}
          }))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.searchIsActive)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              _createElementVNode("li", _hoisted_3, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "flex flex-row no-underline items-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_inline_svg, {
                      src: require('@/assets/logos/ulixee.svg'),
                      height: "23",
                      class: "LOGO inline-block mr-1 relative top-[0.5px]"
                    }, null, 8, ["src"]),
                    _createTextVNode(),
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _createTextVNode(),
              _createElementVNode("li", {
                class: _normalizeClass([[_ctx.isSelected('home') ? 'isSelected' : ''], "hidden md:flex flex-row items-stretch"])
              }, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "no-underline flex flex-row items-center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ], 2),
              _createTextVNode(),
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_Popover, {
                  class: _normalizeClass([[_ctx.isSelected('docs') ? 'isSelected' : ''], "relative flex flex-row items-stretch"])
                }, {
                  default: _withCtx(({ open }) => [
                    _createVNode(_component_PopoverButton, {
                      class: _normalizeClass([open ? 'text-gray-900' : 'text-purple-900', 'font-light group inline-flex items-center hover:text-gray-900 focus:outline-none focus:ring-0'])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createTextVNode(),
                        _createVNode(_component_ChevronDownIcon, {
                          class: _normalizeClass([open ? 'text-gray-600 rotate-180' : 'text-purple-900', 'h-4 w-4 ml-1 stroke-1 duration-100 group-hover:text-gray-500']),
                          "aria-hidden": "true"
                        }, null, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["class"]),
                    _createTextVNode(),
                    _createVNode(_component_DocumentationMenu)
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", {
            class: _normalizeClass([[_ctx.searchIsActive ? 'w-full' : ''], "flex flex-row items-center"])
          }, [
            (_ctx.searchIsActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args))),
                      class: "fixed inset-0 bg-black bg-opacity-30 transition-opacity h-screen w-screen z-30"
                    })
                  ])),
                  _createTextVNode(),
                  _createVNode(_component_SearchForm, { class: "px-[2px] relative z-50" })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args))),
                    class: "cursor-pointer block h-[34px] w-[34px] pt-[5px] text-center rounded hover:bg-ulixee-verylight"
                  }, [
                    _createVNode(_component_inline_svg, {
                      src: require('@/assets/logos/search.svg'),
                      class: "inline-block text-ulixee-normal"
                    }, null, 8, ["src"])
                  ])
                ]))
          ], 2),
          _createTextVNode(),
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", _hoisted_13, [
                _createVNode(_component_inline_svg, {
                  src: require('@/assets/logos/discord.svg'),
                  height: "23",
                  class: "inline-block relative top-px text-ulixee-normal"
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("li", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", _hoisted_16, [
                _createVNode(_component_inline_svg, {
                  src: require('@/assets/logos/github.svg'),
                  height: "24",
                  class: "inline-block text-ulixee-normal"
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("li", _hoisted_17, [
            _createVNode(_component_MenuVersion)
          ])
        ])
      ])
    ], 6),
    _createTextVNode(),
    _createElementVNode("div", {
      class: _normalizeClass([[_ctx.showPadding ? 'p-24' : ''], "min-h-screen"])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    _createTextVNode(),
    _createVNode(_component_Footer)
  ], 2))
}